import { createUseStyles } from 'react-jss';

export default createUseStyles({
  demographicsContainer: {
    display: 'flex',
    height: '600px',
    marginBottom: '20px',
    '@media(max-width: 900px)': {
      flexDirection: 'column',
      alignItems: 'center',
      height: '100%',
      marginBottom: 0,
    }
  },

  plotWrapper: {
    height: '100%',
    width: '100%',
    margin: '20px',
  },
});
